<div class='organizations-main' data-cy="organization-config-container">
  <!-- Global Loading Spinner -->
  <div *ngIf="isSaving" class="saving-overlay" data-cy="organization-config-saving-overlay">
    <mat-progress-spinner mode="indeterminate" data-cy="organization-config-saving-spinner"></mat-progress-spinner>
    <p data-cy="organization-config-saving-text">Saving changes... Please wait.</p>
  </div>

  <!-- Main Content -->
  <mat-progress-spinner *ngIf="!dataOrganizations"
                        style="margin-left: auto; margin-right: auto; position: relative; top: 50%; transform: translateY(-50%);"
                        diameter="100" mode="indeterminate"
                        data-cy="organization-config-loading-spinner">
  </mat-progress-spinner>

  <mat-grid-list *ngIf="dataOrganizations && !isSaving" cols="6" rowHeight="100%" style="height:100%;" data-cy="organization-config-grid">
    <!-- Organizations List -->
    <mat-grid-tile colspan="2" *ngIf="!isDialogMode" data-cy="organization-config-list-tile">
      <mat-card appearance="outlined" style="width:100%; height: calc(100%); display: flex; flex-direction: column;" data-cy="organization-config-list-card">
        <span class="configuration-section-title" data-cy="organization-config-list-title">Organizations</span>
        <div *ngIf="isLoadingOrganizations" style="width: 100% !important; height: 100% !important;" data-cy="organization-config-list-loading">
          <mat-spinner diameter="50" style="margin-left: auto; margin-right: auto; position: relative; top: 20%; transform: translateY(-20%);" data-cy="organization-config-list-spinner"></mat-spinner>
        </div>

        <div *ngIf="!isLoadingOrganizations" style="flex: 1; max-height: 100%; overflow-y: hidden;" data-cy="organization-config-list-content">
          <tdo-table #organizationTable [dataSource]="dataOrganizations" [isSearchable]="true"
                     (rowSelected)="onRowSelected($event)"
                     data-cy="organization-config-table">
            <tdo-table-column displayName="Name" propertyName="OrganizationName" [rowTemplate]="name" data-cy="organization-config-name-column">
              <ng-template #name let-row>
                <span data-cy="organization-config-name-value">{{row.model.OrganizationName}}</span>
              </ng-template>
            </tdo-table-column>
          </tdo-table>
        </div>
      </mat-card>
    </mat-grid-tile>

    <!-- Organization Details -->
    <mat-grid-tile *ngIf="selectedOrganization" [colspan]="isDialogMode ? 6 : 4" data-cy="organization-config-detail-tile">
      <mat-card appearance="outlined" style="width:100%;height:100%" data-cy="organization-config-detail-card">
        <mat-card-content data-cy="organization-config-detail-content">
          <div style="max-width: 700px;" data-cy="organization-config-form-container">
            <span *ngIf="!isDialogMode" class="configuration-section-title" data-cy="organization-config-detail-title">Organization Information.</span>
            <div *ngIf="!isViewOnly && !isDialogMode" data-cy="organization-config-action-container">
              <app-tdo-configuration-action-bar
                [showEdit]="saveDisabled"
                (editClick)="onEdit($event)"
                [saveDisabled]="saveDisabled"
                [showSave]="!saveDisabled"
                [showCancel]="false"
                (saveClick)="onSave($event)"
                (newClick)="onNew($event)"
                [showAdd]="false"
                [newHidden]="isDialogMode"
                data-cy="organization-config-action-bar">
              </app-tdo-configuration-action-bar>
            </div>

            <!-- Organization Form -->
            <div *ngIf="!this.isLoading" data-cy="organization-config-form">
              <!-- Organization Type -->
              <app-validvalueselect style="width:100%"
                                     [disabled]="!this.isEditing"
                                     [dataSource]="organizationTypeEnums"
                                     validvaluename="enumSalutation"
                                     vvplaceholder="Organization Type"
                                     [(selectedValue)]="selectedOrganization.enumOrganizationTypeId"
                                     *ngIf="this.showOrganizationTypeSelection"
                                     data-cy="organization-config-type-select">
              </app-validvalueselect>

              <!-- Organization Name -->
              <app-tdo-input style="width:100%" [(ngModel)]="this.selectedOrganization.OrganizationName"
                             placeholder="Organization Name"
                             [disabled]="!this.isEditing" maxCharacters="200"
                             data-cy="organization-config-name-input">
              </app-tdo-input>

              <!-- Description -->
              <app-tdo-input style="width:100%" [(ngModel)]="this.selectedOrganization.Description"
                             placeholder="Description"
                             [disabled]="!this.isEditing" maxCharacters="2000"
                             data-cy="organization-config-description-input">
              </app-tdo-input>

              <!-- Tabs: Addresses and Contacts -->
              <mat-tab-group style="height: 600px;" mat-align-tabs="start"
                             (selectedTabChange)="onTabChangeAddressContacts($event)"
                             data-cy="organization-config-tabs">
                <mat-tab style="height: 100%; overflow-y: hidden;" label="Address" data-cy="organization-config-address-tab">
                  <div style="padding-top:10px" data-cy="organization-config-address-container">
                    <app-patient-address *ngIf="addresses" style="flex: 1;"
                                         [isAutoOpenFirstItem]="true"
                                         [disabled]="!isEditing"
                                         [allowMultiple]="true"
                                         mode="EditContact"
                                         type="organization"
                                         (claimBillingBlocked)="onClaimBillingBlocked()"
                                         [(data)]="addresses"
                                         data-cy="organization-config-address-component">
                    </app-patient-address>
                  </div>                  
                </mat-tab>
                <mat-tab style="height: 100%; overflow-y: hidden;" label="Contacts / Communications" data-cy="organization-config-contacts-tab">
                  <div style="padding-top:10px" data-cy="organization-config-contacts-container">
                    <div style="flex: 1; flex-direction: column;" data-cy="organization-config-contacts-inner">
                      <app-patient-contacts
                        *ngIf="this.contacts"
                        [disabled]="!isEditing"
                        (errorEvent)="contactErrorMessage($event)"
                        [entityType]="contactEntityType"
                        [entityId]="selectedContactID"
                        [mode]="contactMode"
                        [(data)]="contacts"
                        data-cy="organization-config-contacts-component">
                      </app-patient-contacts>
                    </div>
                  </div>
                </mat-tab>
              </mat-tab-group>
            </div>

            <!-- Loading Spinner -->
            <div *ngIf="this.isLoading" data-cy="organization-config-detail-loading">
              <mat-spinner style="margin-left: auto; margin-right: auto;" data-cy="organization-config-detail-spinner"></mat-spinner>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>
